import { Link } from "react-router-dom";
import { Figure } from "../Figure";
import { ROUTES } from "../../lib/routes";
import { DEPARTMENTS, PG_PROGRAMME_COUNT } from "../../lib/departments";
import { INSTITUTE_RESEARCH } from "../../lib/researchCenters";

// Counted off DEPARTMENTS with the same filters the Academics page uses for its
// two lists, so the card can't drift out of step with the page it links into.
// (It had: 9 branches — the real figure is 13.)
const UG_BRANCHES = DEPARTMENTS.filter((d) => d.kind === "engineering").length;
// Stated, not derived — see PG_PROGRAMME_COUNT in departments.ts: the intake
// table lists seven PG programmes, only four of which have department pages.
/** The Dean (Research) office figure — see INSTITUTE_RESEARCH in researchCenters.ts. */
const RESEARCH_CENTERS = INSTITUTE_RESEARCH.centres;

/**
 * Each card deep-links to the matching h2 on the Academics page.
 *
 * The photos are stock, not BIET's own — licensed under the Unsplash License
 * (commercial use, no attribution required). They are placeholders with a
 * picture rather than a label: swap `photo` for real campus photography of the
 * same 3:2 slot when it exists. `img` stays as the fallback label.
 */
const PROGRAMS = [
  {
    type: "Undergraduate",
    title: "B.E. Programs",
    count: `${UG_BRANCHES} branches`,
    desc: "Computer Science, AI & ML, Data Science, CS & Business Systems, CS & Design, Information Science, ECE, EEE, Mechanical, Civil, Chemical, Textile and Biotechnology.",
    img: "UG · CLASSROOM",
    photo: { url: "sites/biet/academics/ug-classroom.jpg", alt: "A lecturer addressing students seated at desks in a classroom", width: 1600, height: 900 },
    to: `${ROUTES.academics}#undergraduate`,
  },
  {
    type: "Postgraduate",
    title: "M.Tech, MCA & MBA",
    count: `${PG_PROGRAMME_COUNT} programmes`,
    desc: "MCA and MBA alongside M.Tech in Structural Engineering, Environmental Engineering, IoT & Sensor Systems, Cyber Security, and AI & Data Science.",
    img: "PG · SEMINAR",
    photo: { url: "sites/biet/academics/pg-seminar.jpg", alt: "Postgraduate students at a seminar session", width: 1600, height: 1069 },
    to: `${ROUTES.academics}#postgraduate`,
  },
  {
    type: "Research",
    title: "Ph.D. Programs",
    count: `${RESEARCH_CENTERS} centers`,
    desc: "VTU-recognised research centres across CSE, ECE, EEE, Mechanical, Civil, Chemical, Textile, Mathematics, Chemistry, Physics and MCA.",
    img: "RESEARCH · LAB BENCH",
    photo: { url: "sites/biet/academics/research-lab.jpg", alt: "A researcher in a lab coat working at an instrumented laboratory bench", width: 1600, height: 1067 },
    to: `${ROUTES.academics}#research`,
  },
];

export function Academics() {
  return (
    <section className="section section-deep" id="programs">
      <div className="container">
        <div
          className="section-head"
          style={{ borderColor: "rgba(255,255,255,0.15)" }}
        >
          <div>
            <div className="kicker">Academics</div>
            <h2>Programs across every discipline</h2>
          </div>
          <Link
            className="btn-link"
            to={ROUTES.academics}
            style={{ color: "#fff", borderBottomColor: "rgba(255,255,255,0.5)" }}
          >
            All programs <span className="arr">→</span>
          </Link>
        </div>
        <div className="programs-grid">
          {PROGRAMS.map((p, i) => (
            <Link key={i} className="program-card reveal" to={p.to}>
              <Figure
                media={p.photo}
                fallbackLabel={p.img}
                kind="dark"
                aspect="3/2"
                sizes="(max-width: 900px) 92vw, 30vw"
              />
              <div className="program-body">
                <div className="program-meta">
                  <div className="kicker" style={{ color: "var(--gold-400)" }}>
                    {p.type}
                  </div>
                  <span className="program-count">{p.count}</span>
                </div>
                <h3>{p.title}</h3>
                <p>{p.desc}</p>
                <span
                  className="btn-link"
                  style={{ color: "#fff", borderBottomColor: "var(--gold-500)" }}
                >
                  Know more <span className="arr">→</span>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
